import { render, staticRenderFns } from "./purschemeview.vue?vue&type=template&id=7aa1e030&scoped=true&"
import script from "./purschemeview.vue?vue&type=script&lang=js&"
export * from "./purschemeview.vue?vue&type=script&lang=js&"
import style0 from "./purschemeview.vue?vue&type=style&index=0&id=7aa1e030&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa1e030",
  null
  
)

export default component.exports